import * as t from 'io-ts';

import { Currency } from '@catawiki/runtime-toolkit';

export const BiddingCurrency = t.union([
  t.literal(Currency.Currency.EURO),
  t.literal(Currency.Currency.UNITED_STATES_DOLLAR),
  t.literal(Currency.Currency.BRITISH_POUND_STERLING),
]);

export type BiddingCurrency = t.TypeOf<typeof BiddingCurrency>;
